import { useTickets } from "../../../contexts/TicketContext";

const STATUS_COLORS = {
    Open: '#1DA1F2',      // blue
    'On Hold': '#FBC02D', // yellow
    Escalated: '#E74C3C', // red
    Resolved: '#43B581'   // green
};

const statusList = [
    { key: 'Open', label: 'Open', color: STATUS_COLORS.Open },
    { key: 'On Hold', label: 'On Hold', color: STATUS_COLORS['On Hold'] },
    { key: 'Escalated', label: 'Escalated', color: STATUS_COLORS.Escalated },
    { key: 'Closed', label: 'Closed', color: STATUS_COLORS.Resolved },
];

export const YourTicketsChart = ({ tickets: propTickets }) => {
    const { tickets: contextTickets } = useTickets();
    const tickets = propTickets || contextTickets;
    const total = tickets.length;
    const counts = statusList.map(s => tickets.filter(t => t.status === s.key).length);

    return(
        <div className='flex flex-col p-4 items-center justify-between col-span-2 card-container rounded-md'>
            <div className="flex flex-row items-start justify-between w-full">
                <p className="text-font-secondary whitespace-nowrap text-lg">Your Tickets</p>
                <span className="card-container text-xl font-bold text-font-secondary">{total}</span>
            </div>
            <div className='grid grid-cols-2 sm:grid-cols-4 items-center justify-between w-full'>
                {statusList.map((status, idx) => (
                    <div key={status.key} className="flex flex-row items-center justify-start gap-2">
                        <span style={{ color: status.color }} className="text-xl font-bold">{counts[idx]}</span>
                        <span className="text-base text-font-secondary">{status.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
